import { HTMLAttributes, useEffect, useState } from 'react';
import { JoveGridItem } from '@jove-frontend/mui';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import {
  AnalyticsOutlined,
  LanguageOutlined,
  SlowMotionVideoOutlined,
  VerifiedUserOutlined,
} from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import clsx from 'clsx';

type BrokerWhyJoveViewProps = HTMLAttributes<HTMLDivElement> & {
  info: {
    whyJoveSectionTitle: string;
    whyJoveTitle: string;
    whyJoveInfoList: Array<{ title: string; desc: string; icon: string }>;
  };
};

const BrokerWhyJoveView = (props: BrokerWhyJoveViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('flex flex-col items-center', className)}>
      <Box
        className={clsx(
          'flex flex-col items-center',
          isMobileLayout ? 'w-full space-y-1' : 'w-[960px] space-y-5'
        )}
      >
        <Box className="flex flex-row rounded-full bg-[#EBEFFE] px-3 py-2">
          <Typography
            variant="subtitle1"
            className="text-brand-secondary font-extrabold"
          >
            {info?.whyJoveSectionTitle}
          </Typography>
        </Box>
        <Typography
          variant="h4"
          className="text-primary-black text-center font-black"
        >
          {info?.whyJoveTitle}
        </Typography>
        <Grid container spacing={4}>
          {(info?.whyJoveInfoList || []).map((item, index) => {
            return (
              <Grid key={index} item md={6}>
                <JoveGridItem key={index} className="h-full">
                  <Box
                    className="flex h-full flex-col space-y-4 rounded-2xl bg-white p-6"
                    style={{ boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)' }}
                  >
                    {item.icon === 'SlowMotionVideoOutlined' && (
                      <Box className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F8EBFB]">
                        <SlowMotionVideoOutlined className="h-8 w-8 text-[#BB33D5]" />
                      </Box>
                    )}
                    {item.icon === 'VerifiedUserOutlined' && (
                      <Box className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E4FCED]">
                        <VerifiedUserOutlined className="h-8 w-8 text-[#1CB258]" />
                      </Box>
                    )}
                    {item.icon === 'LanguageOutlined' && (
                      <Box className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EBEFFE]">
                        <LanguageOutlined className="h-8 w-8 text-[#0E35D1]" />
                      </Box>
                    )}
                    {item.icon === 'AnalyticsOutlined' && (
                      <Box className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#F7DAE2]">
                        <AnalyticsOutlined className="h-8 w-8 text-[#CD0F47]" />
                      </Box>
                    )}
                    <Typography variant="h5" className="font-black">
                      {item.title}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      className="text-primary-black text-lg font-medium"
                    >
                      {item.desc}
                    </Typography>
                  </Box>
                </JoveGridItem>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Box>
  );
};

export default BrokerWhyJoveView;
